import Handsontable from 'handsontable';
import { HeaderCellType } from 'SharedDir/declarations/fields';

// @ts-ignore
export default class HeaderCell implements Handsontable.nestedHeaders.NestedHeader {
  label!: string;

  colspan: number = 1;

  order: number = 0;

  constructor({ label, colspan, order }: Partial<HeaderCellType> = {}) {
    this.label = label || '';
    if (colspan) {
      this.colspan = colspan;
    }
    if (order) {
      this.order = order;
    }
  }
}
